/**
 *
 * @param {PropertyValueProps} item
 * @param {Boolean} isCalc
 * @returns {Map<"is-composition" | "composition", any>}
 */
const checkComposition = (item, isCalc) => {
  const map = new Map();

  map.set("is-composition", false);
  map.set("composition", null);

  /**
   * Parent is composition
   */
  if (isCalc) {
    const parentData = item.get("parent-item-data");
    const isComposition = parentData.get("is-composition");

    if (isComposition) {
      map.set("is-composition", true);
      map.set("composition", parentData.get("composition"));
    }

    return map;
  }

  /**
   * Value is composition
   */
  const isComposition = item.get("v_is-composition");

  if (isComposition) {
    map.set("is-composition", true);
    map.set("composition", item.get("v_composition"));

    return map;
  }

  /**
   * Default
   */
  return map;
};

export default checkComposition;
